import { Action, Reducer } from 'redux';
import { AppThunkAction } from './';
import * as ActionsAdmin from '../components/Common/ActionAdmin';
import DataManager, { Profile_ToForm, checkNotNull, isEmptyObject } from '../components/Common/DataManager';
import Utils from '../components/Common/Utils';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ClientUserState {
    isLoading: boolean;
    xIndex?: string;
    data: any;
}

interface RequestClientUserAction {
    type: 'REQUEST_CLIENTUSER_DATA';
    xIndex: string;
    data: any;
}

interface ReceiveClientUserAction {
    type: 'RECEIVE_CLIENTUSER_DATA';
    xIndex: string;
    data: any;
}
interface UpdateClientUserAction {
    type: 'UPDATE_CLIENTUSER_DATA';
    xIndex: string;
    data: any;
}

type KnownAction = RequestClientUserAction | ReceiveClientUserAction | UpdateClientUserAction;

export const actionCreators = {    
    requestData: (xIndex: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        console.log(xIndex);
        // Only load data if it's something we don't already have (and are not already loading)
        const appState = getState();
        if (appState && appState.project && xIndex && xIndex !== appState.project.xIndex) {
            fetch(`/api/${ActionsAdmin.Models.Guest}/GuestDataById?id=${xIndex}`, {
                method: 'GET',
                headers: Utils.headerXRequest()
            })
                .then(response => response.json() as Promise<any>)
                .then(xdata => {
                    dispatch({ type: 'RECEIVE_CLIENTUSER_DATA', xIndex: xIndex, data: xdata.data ? Profile_ToForm(xdata.data) : {} });
                });

            dispatch({ type: 'REQUEST_CLIENTUSER_DATA', xIndex: xIndex, data: {} });
        }
        //else if (!xIndex || !checkNotNull(xIndex) || isEmptyObject(xIndex)) {
        //    dispatch({ type: 'UPDATE_CLIENTUSER_DATA', xIndex: xIndex, data: {} });
        //}
    }
};

const unloadedState: ClientUserState = { data: {}, isLoading: false };

export const reducer: Reducer<ClientUserState> = (state: ClientUserState | undefined, incomingAction: Action): ClientUserState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'UPDATE_CLIENTUSER_DATA':
            return {
                xIndex: action.xIndex,
                data: action.data,
                isLoading: false
            };   
        case 'REQUEST_CLIENTUSER_DATA':
            return {
                xIndex: action.xIndex,
                data: state.data,
                isLoading: true
            };
        case 'RECEIVE_CLIENTUSER_DATA':
            if (action.xIndex === state.xIndex) {
                return {
                    xIndex: action.xIndex,
                    data: action.data,
                    isLoading: false
                };
            }
              
            break;
    }

    return state;
};
